import {
  NATIVE_UPDATE_FILTER_CONDITIONS,
  NATIVE_UPDATE_TASKS,
  NATIVE_CHANGE_LOADING
} from "./reducer";
import moment from "moment";
import {fetchNativeTaskApi} from "../../../common/api";
import {UPLOAD_TYPE_ALL} from "../../../consts/uploadtypes";

// 首次进入/重置：按当前筛选条件（默认近 7 天）查第一页，和点「搜索」走同一条路径
export function fetchInitData() {
  return (dispatch, getState) => {
    return dispatch(fetchTasks(getState().nativeList.filterConditions));
  };
}

export function updateFilterConditions(newFilterConditions) {
  return (dispatch, getState) => {
    dispatch({
      type: NATIVE_UPDATE_FILTER_CONDITIONS,
      filterConditions: newFilterConditions
    });
  };
}

export function changeLoading(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: NATIVE_CHANGE_LOADING,
      loading: loading
    });
  };
}

// pageNum 不传即回到第一页；pageSize 不传沿用当前的
export function fetchTasks({deviceId, platform, beginTime, endTime, appId, appVersion, diagnosisId, descriptionKeyword, uploadType}, pageNum = 1, pageSize) {
  return (dispatch, getState) => {
    const currentPageSize = pageSize || getState().nativeList.pagination.pageSize;
    const query = {
      deviceId,
      platform,
      beginTime: moment(beginTime).valueOf(),
      endTime: moment(endTime).valueOf(),
      appId,
      appVersion,
      diagnosisId,
      descriptionKeyword,
      uploadType
    };
    dispatch(changeLoading(true));
    return fetchNativeTaskApi(
      query.deviceId,
      query.platform,
      query.beginTime,
      query.endTime,
      query.appId,
      query.appVersion,
      query.diagnosisId,
      // 「全部」时不传，后端 uploadType 为 null 即不过滤（0 是真实的「未知」值，不能拿来当全部）
      query.uploadType === UPLOAD_TYPE_ALL || query.uploadType === void 0 ? void 0 : query.uploadType,
      pageNum,
      currentPageSize,
      query.descriptionKeyword
    )
      .then(data => {
        // 请求被取消时拦截器会 resolve 出 null，此时保持原列表不动
        if (!data) {
          return;
        }
        dispatch({
          type: NATIVE_UPDATE_TASKS,
          tasks: data.list || [],
          query,
          pagination: {
            pageNum: data.pageNum || pageNum,
            pageSize: data.pageSize || currentPageSize,
            total: data.total || 0
          }
        });
      })
      .then(
        () => dispatch(changeLoading(false)),
        error => {
          dispatch(changeLoading(false));
          return Promise.reject(error);
        }
      );
  };
}

// 翻页/改每页条数：沿用上一次搜索定格的条件重新请求
export function changePage(pageNum, pageSize) {
  return (dispatch, getState) => {
    const { query, filterConditions } = getState().nativeList;
    return dispatch(fetchTasks(query || filterConditions, pageNum, pageSize));
  };
}
